import { render, staticRenderFns } from "./LabelChart.vue?vue&type=template&id=6aeb33ed&scoped=true&lang=pug&"
import script from "./LabelChart.vue?vue&type=script&lang=ts&"
export * from "./LabelChart.vue?vue&type=script&lang=ts&"
import style0 from "./LabelChart.vue?vue&type=style&index=0&id=6aeb33ed&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aeb33ed",
  null
  
)

export default component.exports